import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Observable, combineLatest, distinctUntilChanged, map, shareReplay, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private readonly mobile$: Observable<boolean>;
  private readonly tabletPortrait$: Observable<boolean>;
  private readonly widthSmall$: Observable<boolean>;

  constructor(private breakpointObserver: BreakpointObserver, private platform: Platform) {
    this.mobile$ = this.breakpointObserver.observe([Breakpoints.Handset]).pipe(
      map((result) => result.matches),
      startWith(this.platform.is('mobile')),
      shareReplay({ refCount: true, bufferSize: 1 }),
      distinctUntilChanged()
    );
    this.tabletPortrait$ = this.breakpointObserver.observe([Breakpoints.TabletPortrait]).pipe(
      map((result) => result.matches),
      startWith(this.platform.is('tablet') && this.platform.isPortrait()),
      shareReplay({ refCount: true, bufferSize: 1 }),
      distinctUntilChanged()
    );
    this.widthSmall$ = this.breakpointObserver.observe([`(max-width: 1023px)`]).pipe(
      map((result) => result.matches),
      shareReplay({ refCount: true, bufferSize: 1 }),
      distinctUntilChanged()
    );
  }

  showMobileView(): Observable<boolean> {
    return combineLatest([this.mobile$, this.tabletPortrait$, this.widthSmall$]).pipe(
      map(([isMobile, isTabletPortrait, widthSmall]) => isMobile || isTabletPortrait || widthSmall)
    );
  }
}
